import withStyles from '@material-ui/core/styles/withStyles'
import Button from '@material-ui/core/Button'
import grey from '@material-ui/core/colors/grey'

export const GreyButton = withStyles(() => ({
  root: {
    color: 'white',
    backgroundColor: grey[400],
    '&:hover': {
      backgroundColor: grey[700],
    },
  },
}))(Button)
